import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { withJsonErrorBody } from '../utils/http-error';

/**
 * HTTP Interceptor to handle errors globally
 * Note: 401 errors are handled by authInterceptor for silent token refresh
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    // A file download's error body arrives as a Blob: read it back once here, so the screens and the
    // error helper see the server's reason as for any other request
    catchError((error: unknown) =>
      req.responseType === 'blob'
        ? from(withJsonErrorBody(error)).pipe(switchMap((read) => throwError(() => read)))
        : throwError(() => error)
    ),
    catchError((error: HttpErrorResponse) => {
      // A 4xx is an answer the calling screen handles (not found, refused, invalid), and status 0
      // is a request the browser aborted or never completed (page left, connection dropped);
      // only a server error is logged here
      if (error.status >= 500) {
        // Console log only, never shown to a user
        /* eslint-disable no-restricted-syntax */
        const errorMessage =
          error.status === 500
            ? 'Internal server error - Please try again later'
            : error.error?.message || error.error?.error || `Error Code: ${error.status}`;
        /* eslint-enable no-restricted-syntax */
        console.error('[Error Interceptor] HTTP Error:', req.url, errorMessage);
      }

      return throwError(() => error);
    })
  );
};
